import { jsx as _jsx } from "react/jsx-runtime";
import { s } from './common.js';
export function ImageComponent(props) {
    const src = s(props.config, 'src');
    const alt = s(props.config, 'alt');
    const maxWidth = s(props.config, 'maxWidth');
    if (!src)
        return null;
    return (_jsx("img", { src: src, alt: alt, className: "block h-auto w-full rounded-md", style: maxWidth ? { maxWidth } : undefined }));
}
export const ImageArchetype = {
    name: 'Image',
    label: 'Image',
    description: 'Responsive image with required alt text.',
    component: ImageComponent,
    isFormArchetype: false,
    fields: {
        src: { kind: 'text', label: 'Image URL' },
        alt: { kind: 'text', label: 'Alt text' },
        maxWidth: { kind: 'text', label: 'Max width (CSS)', optional: true },
    },
    defaultConfig: { src: '', alt: '', maxWidth: '' },
};
